var _path, _rect, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTinyChatTriangle = function SvgTinyChatTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9995 0.5C43.828 0.5 44.4995 1.17156 44.4995 1.99999L44.5 47.2674C44.5 48.6441 42.8006 49.2936 41.8824 48.2679L1.35725 3.0005C0.492296 2.03433 1.17805 0.5 2.47484 0.5H42.9995Z",
    fill: "#1C1C1E",
    stroke: "#2C2C2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 0.5,
    width: 451,
    height: 138,
    rx: 9.5,
    fill: "#1C1C1E",
    stroke: "#2C2C2E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_12040_32129",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.98451 3.334L9.99979 13.4043V129C9.99979 134.523 14.4769 139 19.9998 139H452C457.523 139 462 134.523 462 129V10C462 4.47715 457.523 0 452 0H42.9993H19.9998H2.47463C0.745582 0 -0.168766 2.04577 0.98451 3.334Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.98451 3.334L9.99979 13.4043V129C9.99979 134.523 14.4769 139 19.9998 139H452C457.523 139 462 134.523 462 129V10C462 4.47715 457.523 0 452 0H42.9993H19.9998H2.47463C0.745582 0 -0.168766 2.04577 0.98451 3.334Z",
    fill: "#1C1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99979 13.4043H10.9998V13.022L10.7448 12.7373L9.99979 13.4043ZM0.98451 3.334L0.239455 4.001L0.239455 4.001L0.98451 3.334ZM10.7448 12.7373L1.72957 2.667L0.239455 4.001L9.25473 14.0713L10.7448 12.7373ZM10.9998 129V13.4043H8.99979V129H10.9998ZM19.9998 138C15.0292 138 10.9998 133.971 10.9998 129H8.99979C8.99979 135.075 13.9246 140 19.9998 140V138ZM452 138H19.9998V140H452V138ZM461 129C461 133.971 456.97 138 452 138V140C458.075 140 463 135.075 463 129H461ZM461 10V129H463V10H461ZM452 1C456.97 1 461 5.02944 461 10H463C463 3.92487 458.075 -1 452 -1V1ZM42.9993 1H452V-1H42.9993V1ZM19.9998 1H42.9993V-1H19.9998V1ZM2.47463 1H19.9998V-1H2.47463V1ZM1.72957 2.667C1.15293 2.02289 1.6101 1 2.47463 1V-1C-0.118934 -1 -1.49046 2.06865 0.239455 4.001L1.72957 2.667Z",
    fill: "#2C2C2E",
    mask: "url(#path-3-inside-1_12040_32129)"
  })));
};
export { SvgTinyChatTriangle as ReactComponent };
export default __webpack_public_path__ + "tiny-chat-triangle.svg";